import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-expandable-card',
    templateUrl: './expandable-card.component.html',
    styleUrls: ['./expandable-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ExpandableCardComponent {
    showContent = false;

    toggleContent() {
        this.showContent = !this.showContent;
    }
}
